import { CancelTokenSource } from "axios";
import { Config } from "../core/config/config.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Context } from "../core/components/commonApp.js";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

export const openChat = (context: Context) => {
    const targetElement = $("<div>");
    const overlay = $("<div>");
    overlay.attr("class", "k-overlay")
    $("body").append(targetElement);
    $("body").append(overlay);
    const root = ReactDOM["createRoot"](targetElement[0]);
    const onClose = () => {
        root.unmount();
        targetElement[0].remove();
        overlay[0].remove();
    }
    root.render(<ChatDialog onClose={onClose} context={context} />);
}
class ChatService {
    private source: EventSource;
    private resolve: any;
    cancelRequests = () => {
        if (this.source)
            this.source.close();
        if (this.resolve)
            this.resolve();
    }

    currentTimeout;
    ask = (ticketId: number, msg: string, onUpdate: (str: string) => void) => {
        const STOP_TOKEN = "~~E*N*D*~~"
        return new Promise<void>(async (resolve) => {
            this.resolve = resolve;
            this.source = new EventSource(Config.baseUrl + `ChatAssistant/AskWithStreamingAsync?ticketId=${ticketId}&msg=${msg}`);

            this.source.onmessage = (e) => {
                console.log(e.data);
                if (e.data == STOP_TOKEN) {
                    this.source.close();
                    resolve()
                }
                else {
                    onUpdate(JSON.parse(e.data).message);
                }
            }
            this.source.onerror = () => {
                this.source.close();
            };
        })
    }

}

interface ChatDialogProps {
    onClose: () => void;
    context: Context;
}
interface ChatDialogState {
    messages: ChatMessage[];
    isLoading: boolean;
}
class ChatDialog extends React.Component<ChatDialogProps, ChatDialogState> {
    private messagesRef: HTMLDivElement;
    private textboxRef: Textbox;
    private chatService: ChatService = new ChatService();
    private suggestions = [
        ChatMessage.Suggestion(Helper.getTranslation("WebSMS.AI.SummarizeTicket")),
        ChatMessage.Suggestion(Helper.getTranslation("WebSMS.AI.WhoInvolvedInTicket"))
    ];
    constructor(props: ChatDialogProps) {
        super(props)
        this.state = {
            messages: [
                ChatMessage.BotMessage(Helper.getTranslation("WebSMS.AI.HowCanIServe"))
            ],
            isLoading: false
        }
    }

    private pushMessage = (msg: ChatMessage) => {
        let messages = this.state.messages
        messages.push(msg);
        this.setState({ messages: messages }, this.scrollDown);
    }

    private updateMessage = (msg: ChatMessage) => {
        const messages = this.state.messages;
        const index = messages.findIndex(f => f.id == msg.id);
        messages[index] = msg;
        this.setState({ messages: messages }, this.scrollDown);
    }

    private scrollDown = () => {
        this.messagesRef.scrollTo(0, this.messagesRef.scrollHeight)
    }

    private pushNewMessage = async (msg: string) => {
        this.setState({ isLoading: true })
        const userMsg = ChatMessage.UserMessage(msg);
        this.pushMessage(userMsg);
        const botMsg = ChatMessage.BotMessage("");
        this.pushMessage(botMsg);
        await this.chatService.ask(this.props.context.keyVal1, msg, (str) => {
            botMsg.push(str);
            this.updateMessage(botMsg);
        });
        this.setState({ isLoading: false }, () => {
            this.textboxRef.focus();
        })
    }

    private cancel = () => {
        const messages = this.state.messages;
        const msg = messages[messages.length - 1];
        msg.push("\n\n__Request was canceled__")
        this.updateMessage(msg);
        this.chatService.cancelRequests()
    }

    private close = () => {
        this.chatService.cancelRequests()
        this.props.onClose();
    }

    private renderClarification = () => {
        const key = `Dont_Show_Clarification_${Config.user.userName}`;
        const showClarification = !Helper.loadDataFromStorage(key);
        const onClick = () => {
            Helper.saveDataToStorage(key, true, false)
            this.setState({})
        }

        return (
            <div className="clarification" style={{ display: showClarification ? "flex" : "none" }}>
                <div>
                    {Helper.getTranslation("WebSMS.AI.BotCanMakeMistakes")}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <label onClick={onClick}>
                        {Helper.getTranslation("WebSMS.AI.HideAIWarning")}
                    </label>
                </div>
            </div>
        );
    }

    private renderMessages = () => {
        const onClick = (chatMessage: ChatMessage) => {
            switch (chatMessage.participant) {
                case "bot":
                    navigator.clipboard.writeText(chatMessage.message);
                    //NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.SavedToClipboard"))
                    break;
                case "suggestion":
                    this.pushNewMessage(chatMessage.message)
                    break;
            }
        }
        let suggestions = <></>
        if (this.state.messages.length == 1) {
            suggestions = (
                <div className="suggestions">
                    {this.suggestions.reverse().map((msg) => msg.toHTML(onClick))}
                </div>
            );
        }


        return (
            <div className="messages" >
                <div ref={(ref) => { this.messagesRef = ref }}>
                    {this.state.messages.map((msg) => msg.toHTML(onClick))}
                    {suggestions}
                </div>
            </div>
        );
    }

    componentWillUnmount() {
        this.chatService.cancelRequests()
    }

    render() {
        const header = (
            <div className="chat_dialog__header">
                <div className="chat_dialog__header__label">
                    {Config.settings.openAI.name ?? "Walter"}
                </div>
                <div className="chat_dialog__header__btn">
                    <i className="fa-light fa-xmark-large" onClick={this.close}></i>
                </div>
            </div>
        );

        const note = (
            <div className="note">
                <label>Powered by OpenAI</label>
                <div>
                    <svg viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><title>OpenAI icon</title>
                        <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
                    </svg>
                </div>
            </div>
        );


        return (
            <>
                <div className="chat_dialog">
                    {header}
                    {this.renderClarification()}
                    {this.renderMessages()}
                    <Textbox pushNewMessage={this.pushNewMessage} cancel={this.cancel} loading={this.state.isLoading} ref={(ref) => { this.textboxRef = ref }} />
                    {note}
                </div>
            </>
        )
    }
}
interface TextboxProps {
    cancel: () => void;
    pushNewMessage: (msg: string) => void;
    loading: boolean;
}
interface TextboxState {
    value: string;
}
class Textbox extends React.Component<TextboxProps, TextboxState> {
    private inputRef: HTMLInputElement;

    constructor(props: TextboxProps) {
        super(props)

        this.state = {
            value: ""
        }
    }

    private pushNewMessage = () => {
        if (!Helper.isNullOrEmpty(this.state.value)) {
            this.props.pushNewMessage(this.state.value)
            this.setState({ value: "" })
        }
    }

    private onKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
        if (event.key == "Enter" && !event.shiftKey) {
            this.pushNewMessage();
        }
    }

    private onChange = (event) => {
        this.setState({ value: event.target.value })
    }

    private renderIcon = () => {
        if (this.props.loading) {
            return <Icon disabled={false} icon={"stop-circle"} onClick={this.props.cancel} />
        } else {
            const disabled = Helper.isNullOrEmpty(this.state.value);
            return <Icon disabled={disabled} icon={"paper-plane-top"} onClick={this.pushNewMessage} />
        }
    }

    focus = () => {
        this.inputRef.focus();
    }


    componentDidMount() {
        this.focus();
    }

    render() {
        return (
            <div className="textbox">
                <input type="text" value={this.state.value} onChange={this.onChange} onKeyPress={this.onKeyPress} disabled={this.props.loading} ref={(ref) => { this.inputRef = ref }}></input>
                {this.renderIcon()}
            </div>
        );
    }
}
class Icon extends React.Component<{ onClick: () => void; icon: string; disabled: boolean }, { hovered: boolean }> {
    constructor(props) {
        super(props);

        this.state = {
            hovered: false
        }
    }

    private onMouseEnter = () => {
        if (!this.props.disabled) {
            this.setState({ hovered: true })
        }
    }

    private onMouseLeave = () => {
        this.setState({ hovered: false })
    }

    render() {
        const className = "icon_wrapper " + (this.props.disabled ? "disabled" : "enabled");
        return (
            <div className={className}>
                <i className={`fa-${this.state.hovered ? "solid" : "light"} fa-${this.props.icon} fa-2x`} onClick={this.props.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}></i>
            </div>
        );
    }

}

type Participant = "user" | "bot" | "suggestion";
class ChatMessage {

    static Suggestion(msg: string): ChatMessage {
        return new ChatMessage(msg, "suggestion");
    }

    static UserMessage(msg: string): ChatMessage {
        return new ChatMessage(msg, "user");
    }

    static BotMessage(msg: string): ChatMessage {
        return new ChatMessage(msg, "bot");
    }
    constructor(msg: string, participant: Participant) {
        this.message = msg;
        this.participant = participant;
        this.id = kendo.guid(),
            this.timestamp = (new Date()).getTime();
    }

    message: string;
    timestamp: number;
    participant: Participant;
    id: string;

    update(msg: string) {
        this.message = msg;
    }

    push(msg: string) {
        if (msg != null)
            this.message += msg;
    }

    private toInnerHTML() {
        const boldRegex = /([\*]{2}.+?[\*]{2})/g;
        const toStrong = (s: string) => {
            return `<strong>${this.replaceAll(s, "**", "")}</strong>`
        }
        const boldFnc = this.formatFncFactory(boldRegex, toStrong);

        const ticketRegex = /(\b\d{6,}\b)/g;
        const toAnchor = (s: string) => {
            const ticketId = this.replaceAll(s, "", "");
            return `<a href="${Config.baseUrl}Procedure/Read?id=${ticketId}" target="_blank">${ticketId}</a>`
        }
        const anchorFnc = this.formatFncFactory(ticketRegex, toAnchor);

        const italicRegex = /([\_]{2}.+?[\_]{2})/g;
        const toItalic = (s: string) => {
            return `<i>${this.replaceAll(s, "__", "")}</i>`
        }
        const italicFnc = this.formatFncFactory(italicRegex, toItalic);


        let tmp = this.message.trim();
        tmp = this.imageFnc(tmp);
        tmp = boldFnc(tmp);
        tmp = italicFnc(tmp);
        tmp = anchorFnc(tmp);
        tmp = this.replaceAll(tmp, "**", "");
        return tmp;
    }

    toHTML(onClick: (chatMessage: ChatMessage) => void) {

        if (this.isNullOrEmpty()) {
            return (
                <div key={this.id} className={`message ${this.participant}`}>
                    <div style={{ width: "100px", padding: "5px" }}>
                        <span className="loader"></span>
                    </div>
                </div>
            )
        }

        const html = this.toInnerHTML();
        return (
            <div key={this.id} className={`message ${this.participant}`}>
                <div onClick={() => { onClick(this) }} dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
        );
    }

    private imageFnc = (msg: string) => {
        const imageRegex = new RegExp("!\\[.*?\\]\\(.+?\\)");
        const altRegex = new RegExp("\\[.*?\\]");
        const guidRegex = new RegExp("(?:\\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\\}{0,1})");
        if (imageRegex.test(msg)) {
            const arr = imageRegex.exec(msg)
            for (let i = 0; i < arr.length; i++) {
                const tmp = arr[0];
                const alt = altRegex.test(tmp) ? altRegex.exec(tmp)[0].replace("[", "").replace("]", "") : "";
                const imageId = guidRegex.test(tmp) ? guidRegex.exec(tmp)[0] : "";
                var html = `<div style="margin-top: 15px"><img src="${Config.baseUrl}ChatAssistant/Image/${imageId}" style="width: 100%; border: 1px solid #C1C8CD; border-radius: var(--border-radius)" alt="${alt}"></img></div>`
                msg = msg.replace(tmp, html);

            }
        }

        return msg
    }

    private isNullOrEmpty = () => {
        return Helper.isNullOrEmpty(this.message)
    }

    private formatFncFactory = (regEx: RegExp, fnc: (str: string) => string) => {
        return (msg: string) => {
            const tmp = msg.split(regEx).map((s) => {
                if (s.match(regEx)) {
                    return fnc(s)
                }
                return s

            });
            return tmp.join("");
        };
    }

    private replaceAll = (value: string, from: string, to: string) => {
        return value.split(from).join(to)
    }
}



